import { FC, ReactNode } from 'react';
import { ButtonsWrapper, Container, TitleContainer } from './../Registration.styles';
import { ArrowBack, SaveOutlined } from '@mui/icons-material';
import { Button, Section } from '../../../components';
import { useLocation, useNavigate } from 'react-router-dom';

interface RegistrationNewPage {
	title: string;
	children: ReactNode;
	onSubmit: () => void;
	desabledButton?: boolean;
}

const RegistrationFormPage: FC<RegistrationNewPage> = ({ title, children, onSubmit, desabledButton }) => {
	const navigate = useNavigate();
	const { pathname } = useLocation();

	return (
		<Container>
			<Section>
				<TitleContainer>
					<h1>{title}</h1>
				</TitleContainer>
				{children}
				<ButtonsWrapper>
					<Button
						variant='text'
						onClick={() => {
							navigate(pathname.split('/').slice(0, 3).join('/'));
						}}
						type='button'
					>
						<ArrowBack fontSize='medium' />
						<span>Voltar</span>
					</Button>
					<div>
						<Button disabled={desabledButton} variant='contained' onClick={onSubmit} fitContent type='button'>
							<SaveOutlined fontSize='medium' />
							<span>Salvar</span>
						</Button>
					</div>
				</ButtonsWrapper>
			</Section>
		</Container>
	);
};

export default RegistrationFormPage;
